import ResourcesHero from "./ResourcesHero";

export default ResourcesHero;
